import React from "react";
import RoleSelect from "../../lib/RoleSelect";
import GroupSelect from "../../lib/GroupSelect";
import { KTIcon } from "../../../../../_metronic/helpers";
import FormError from "../../lib/FormError";
import { FormLabel } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { REQUIRED_FIELD_MESSAGE } from "../../../../CONSTANTS";
import { runToast } from "../../../../../_metronic/helpers/utils";
import { resetPassword } from "../../../../api/operator/operatorApi";
import { useNavigate } from "react-router-dom";

/* Main Component */
function UserForm({
  formik, //Formik all detailes from parent component
  openShowImagesModal, //image selector modal handler
  labels, //form lables
  userId,
  editable = false, //use for filter input item in edit & create mode
}: {
  formik: any;
  openShowImagesModal: any;
  labels: { sendBtnLabel: string };
  userId?: string;
  editable?: boolean;
  
}) {
  return (
    <>
      <form onSubmit={(e) => {
        e.preventDefault();
        const submitValues = {
          ...formik.values,
          activation: formik.values.activation || 1 // اگر activation نداشت، 1 قرار بده
        };
        formik.handleSubmit(submitValues);
      }} className={"form card"}>
        <div className={"card-body"}>
          <div className={"row  row-gap-10  mb-6"}>
            {/* <div className={"col-12 col-sm-6 col-lg-6 "}>
              <FormLabel>نام کارشناس</FormLabel>
              <input
                {...formik.getFieldProps("f_name")}
                className={"form-control form-control-lg form-control-solid "}
                placeholder={"نام کارشناس"}
              />
              <FormError formik={formik} fieldName={"title"} />
            </div> */}

            <TextInputItem
              title="نام کارشناس"
              fieldName="f_name"
              hint="نام کارشناس"
              formik={formik}
            />

            <TextInputItem
              title="نام خانوادگی کارشناس"
              fieldName="l_name"
              hint="نام خانوادگی کارشناس"
              formik={formik}
            />

            <TextInputItem
              title="شماره موبایل"
              fieldName="mobile"
              hint="Ex : 9123456789"
              formik={formik}
              type="number"
            />

            <TextInputItem
              title="ایمیل"
              fieldName="email"
              hint="Ex : example@mail.com"
              formik={formik}
              type="email"
            />

            <TextInputItem
              title="کد ملی"
              fieldName="nationalCode"
              hint="Ex : 1234567890"
              formik={formik}
              type="number"
            />

            <TextInputItem
              title="شماره پرسنلی"
              fieldName="personalCode"
              hint="شماره پرسنلی"
              formik={formik}
              type="number"
            />

            <div className={"col-12 col-sm-6 col-lg-6 "}>
              <FormLabel>نقش کارشناس</FormLabel>
              <RoleSelect formik={formik} withDefault={editable} />
            </div>

            <div className={"col-12 col-sm-6 col-lg-6 "}>
              <FormLabel>نام واحد</FormLabel>
              <GroupSelect formik={formik} withDefault={editable} />
            </div>

            <div className={"col-12 col-sm-6 col-lg-6"}>
              <FormLabel>وضعیت کاربر</FormLabel>
              <div className="d-flex gap-4">
                <TextInputItem
                  title="فعال"
                  fieldName="activation"
                  hint=""
                  formik={formik}
                  isRadio={true}
                  value={1}
                />
                <TextInputItem
                  title="غیرفعال"
                  fieldName="activation"
                  hint=""
                  formik={formik}
                  isRadio={true}
                  value={-1}
                />
              </div>
            </div>

            <TextInputItem
              title="نام کاربری"
              fieldName="usernameC"
              hint="نام کاربری"
              formik={formik}
            />
            {/* <div className={"col-12 col-sm-6 col-lg-6 "}>
                            <FormLabel>وضعیت</FormLabel>
                            <StatusCom isActive={formik.values.activation === 1} />
                        </div> */}
            {/* When use from the Edit, show password and image selector inputs */}
            {!editable && (
              <>
                <TextInputItem
                  title="رمز عبور"
                  fieldName="passwordC"
                  hint="رمز عبور"
                  formik={formik}
                  type="password"
                />

                <TextInputItem
                  title="تکرار رمز عبور"
                  fieldName="confirmPassword"
                  hint="رمز عبور"
                  formik={formik}
                  type="password"
                />
              </>
            )}

            <div className={"col-12   "}>
              {/*<div className={"p-2 border d-flex align-items-center  gap-2"}>*/}
              {/*    <button*/}
              {/*        type={"button"}*/}
              {/*        onClick={openShowImagesModal}*/}
              {/*        className={"btn btn-primary d-flex align-items-center btn-sm"}*/}
              {/*    >*/}
              {/*        انتخاب عکس*/}
              {/*    </button>*/}
              {/*    <span>{formik.values.imageName || "عکس انتخاب نشده!"}</span>*/}
              {/*</div>*/}
            </div>
          </div>

          <div className={"mt-4"}>
            <button
              disabled={!formik.isValid || !formik.dirty}
              type={"submit"}
              className={"btn btn-primary d-flex align-items-center gap-2"}
            >
              {labels.sendBtnLabel}
              <span>
                <KTIcon iconName={"send"} className={"fs-2"} />
              </span>
            </button>
          </div>
        </div>
      </form>
      {editable && <ResetPassword id={userId as string} />}
    </>
  );
}

const TextInputItem = ({
  title,
  hint,
  formik,
  fieldName,
  type = "text",
  isRadio = false,
  value,
}: {
  title: string;
  hint: string;
  formik: any;
  fieldName: string;
  type?: string;
  isRadio?: boolean;
  value?: number;
}) => {
  if (isRadio) {
    return (
      <div className="form-check form-check-custom form-check-solid">
        <input
          type="radio"
          className="form-check-input"
          name={fieldName}
          value={value}
          checked={formik.values[fieldName] === value}
          onChange={() => formik.setFieldValue(fieldName, value)}
        />
        <label className="form-check-label">{title}</label>
      </div>
    );
  }

  return (
    <div className={"col-12 col-sm-6 col-lg-6 "}>
      <FormLabel>{title}</FormLabel>
      <input
        {...formik.getFieldProps(fieldName)}
        className={"form-control form-control-lg form-control-solid "}
        placeholder={hint}
        type={type}
      />
      <FormError formik={formik} fieldName={fieldName} />
    </div>
  );
};

function ResetPassword({ id }: { id: string }) {
  const navigate = useNavigate();
  const initialValues = {
    passwordC: "",
    confirmPassword: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      passwordC: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required(REQUIRED_FIELD_MESSAGE),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("passwordC")], "Passwords must match")
        .required(REQUIRED_FIELD_MESSAGE),
    }),
    onSubmit: async (values) => {
      try {
        const res = await resetPassword({
          id,
          password: values.passwordC,
          confirmPassword: values.confirmPassword,
        });
        if (res) {
          runToast("با موفقیت انجام شد", "success");
          formik.resetForm();
          navigate(-1);
        }
      } catch (e) {
        runToast("اشکال در ارسال", "error");
      }
    },
  });
  return (
    <div className=" mt-10 mb-10 mb-xl-10 card ">
      <div
        className={
          "card-title mt-5 mb-1 px-10 d-flex align-items-center justify-content-between bg-white" +
          " pt-5"
        }
      >
        <h2>تغییر رمز عبور</h2>
      </div>
      <hr className=" text-muted" />
      <div className="card-body form">
        <form onSubmit={formik.handleSubmit} className={"row  row-gap-10  "}>
          <TextInputItem
            title="رمز عبور"
            fieldName="passwordC"
            hint="رمز عبور"
            formik={formik}
            type="password"
          />

          <TextInputItem
            title="تکرار رمز عبور"
            fieldName="confirmPassword"
            hint="رمز عبور"
            formik={formik}
            type="password"
          />
          <div className={"mt-1"}>
            <button
              disabled={!formik.isValid || !formik.dirty}
              type={"submit"}
              className={"btn btn-primary d-flex align-items-center gap-2"}
            >
              تغییر رمز عبور
              <span>
                <KTIcon iconName={"pencil"} className={"fs-2"} />
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UserForm;
